"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizeDate = exports.localizeCost = void 0;
var Moment = require("moment");
var localizeCost = function (cost, locale, currency) {
    return new Intl.NumberFormat(locale, { currency: currency, style: "currency" }).format(!cost || cost < 0 ? 0 : cost);
};
exports.localizeCost = localizeCost;
var localizeDate = function (date, locale) {
    var _a;
    return Moment.utc(date).isValid()
        ? (_a = new Intl.DateTimeFormat(locale, {
            dateStyle: "medium",
            timeZone: "UTC",
        })) === null || _a === void 0 ? void 0 : _a.format(date)
        : "";
};
exports.localizeDate = localizeDate;
//# sourceMappingURL=localizationUtils.js.map